import { Deserializable } from '../protocols/deserializable';

export class RolePermission implements Deserializable {
  public id!: number;
  public permissionId!: number;
  public accessGranted!: boolean;

  onDeserialize(): void {}
}
